import { Injectable } from '@angular/core';

import { Product } from '@bytel/bytel-sales';

import { ConfigurationService } from '@services/configuration.service';

@Injectable()
export class ProductHelper {
    public constructor(protected configurationService: ConfigurationService) {}

    public getDefaultImage(product: Product): string {
        const domain: string = this.configurationService.getData()?.global.origin;
        return `${domain}${product.smallImage}`;
    }

    public getImages(product: Product): string {
        const domain: string = this.configurationService.getData()?.global.origin;
        return `${domain}${product.imageHD ?? product.smallImage} 200w,
        ${domain}${product.smallImage} 400w`;
    }

    public getMedias(product: Product): string[] {
        const domain: string = this.configurationService.getData()?.global.origin;
        return product.medias.map((media: string) => `${domain}/${media}`);
    }

    public getWiderImages(product: Product): string {
        const domain: string = this.configurationService.getData()?.global.origin;
        return `${domain}${product.image} 400w`;
    }
}
